import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Table, Popover,ConfigProvider,theme} from 'antd';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import help from '../../config/help.json';
import {CSVLink} from 'react-csv';


import './analytics.css';


var cc_data;


class AdLocationCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}


	render() {
		const { defaultAlgorithm, darkAlgorithm } = theme;
		const { userTheme,opensearchAdImpressionByLocationList } = this.props;

		cc_data = opensearchAdImpressionByLocationList || [];

		// takes an array of objects and the name of a property of these objects
		function getGroupByKeys(array, index){
			let temparr = [];
			array.forEach(d => {
				if(d && d[index]){
					if(!temparr.some(f => f.text === d[index])){
						temparr.push({text:d[index], value:d[index]})
					}
				}
			})
			return temparr;
		}
		// let dataset = [];
		// cc_data.map((d) => {
		// 	let temp = [];
		// 	temp.push(d.key,d.doc_count);
		// 	dataset.push(temp);
		// });
		// const option = {
		// 	dataset: {
		// 		source: dataset
		// 	  },
		// 	grid: { containLabel: true },
		// 	toolbox: {
		// 		showTitle: false,
		// 	  show: true,
		// 	  orient: 'vertical',
		// 	  left: 'right',
		// 	  top: 'center',
		// 	  feature: {
		// 		mark: { show: true },
		// 		dataView: { show: true, readOnly: false, lang:['Data View', 'Close', 'Refresh'],title:'Data View' },
		// 		magicType: { show: true, type: ['line'],title:{line:'Line Chart', bar:'Bar Chart',stack:'Stack Chart',tiled:'Tiled Chart' }},
		// 		restore: { show: true, title:'Refresh' },
				
		// 	  }
		// 	},
		// 	tooltip: {
		// 	  trigger: 'axis',
		// 	  axisPointer: {
		// 		type: 'shadow'
		// 	  }
		// 	},
		// 	xAxis: { type: 'value' },
		// 	yAxis: { type: 'category' },
		// 	series: [
		// 	  {
		// 		type: 'bar'
		// 	  }
		// 	]
		//   };
		const columns = [
			{
			  title: 'Ad Location',
			  dataIndex: 'key',
			  filters: getGroupByKeys(cc_data, "key"),
			  onFilter: (value, record) => record.key.indexOf(value) === 0,
			  sorter: (a, b) => a.key.localeCompare(b.key),
			  
			},
			{
			  title: 'Count',
			  dataIndex: 'doc_count',
			  sorter: (a, b) => a.doc_count - b.doc_count,
				defaultSortOrder: 'descend',
			  
			}
		  ];

		return (
			<ConfigProvider theme={{
				algorithm: userTheme === 'dark' ?darkAlgorithm : defaultAlgorithm,
			  }}>
      <Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`Ad impression by Ad location  `}
					<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='AdLocationCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={cc_data.map(c => ({ adLocation:c.key, count:c.doc_count}))} target="_blank" filename={"Ad impression by Ad location.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				
				<Row>
				 <Col span={24}>
				 	<Table theme={userTheme} dataSource={cc_data} columns={columns} pagination={{pageSize:5}} />
					{/* <ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{color:"#74add1"}} /> */}
				</Col>
 				</Row>
     </Card>
	 </ConfigProvider>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchAdImpressionByLocationList: state.advertisement.opensearchAdImpressionByLocationList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdLocationCard));
